.ux-iws-event-calendar {
    &__header {
        display: flex;
        flex-flow: column-reverse;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
        margin-top: 20px;

        @media (min-width: 568px) {
            margin-top: 40px;
            flex-flow: row nowrap;
        }
    }

    &__calendar {
        box-sizing: border-box;
        display: flex;
        flex-flow: row wrap;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 0 0 auto;
        width: 100%;
        margin-bottom: 40px;

        @media (min-width: 568px) {
            width: calc(100% * 7 / 12);
            border-left: 1px solid $color-gray-background;
            padding-left: 16px;
        }
    }

    &__filter {
        width: 100%;

        @media (min-width: 568px) {
            width: calc(100% * 5 / 12);
            margin-bottom: 40px;
            padding-right: 16px;
        }

        .ux-iws-search-tag-group__tags {
            display: flex;
            flex-flow: row wrap;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 10px;
        }

        .ux-iws-search-tag-group__tags ux-iws-search-tag {
            flex: 0 0 auto;
            margin: 0;
        }

        form {
            margin: 0;
        }
    }

    &__hidden {
        display: none;
    }

    &__no-results {
        display: none;

        .ux-iws-event-calendar--no-results & {
            display: block;
        }
    }

    &__form {
        margin: 0;
        padding: 0;
    }

    &__field:not(:last-of-type) {
        margin-bottom: 40px;
    }

    &--compact .ux-iws-event-calendar__calendar {
        @media (max-width: 567px) {
            margin-bottom: 0;
        }
    }

    ux-iws-search-tag-filter {
        padding-top: 6px;
    }

    /** FIXME: the ux-select does not apply text-transform correctly */
    ux-select .ux-label__text {
        text-transform: uppercase;
    }
}
